export default __webpack_public_path__ + "static/media/24.fde54b04.png";